import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import CorporateLayout from "../Layout";
import HubHeader from "../Layout/topHeader";
import { getPage, getParamValue } from "../../../utils/index";
import Loading from "../../common/Loader";
import { EditOutlined } from "@ant-design/icons";
import { Button, Drawer, Empty, Form } from "antd";
import AddEmployeeGroup from "./AddEmployeeGroup";
import PaginationTwo from "../../common/PaginationTwo";
import { authenticateToken } from "../../../utils/auth";
import axios from "axios";
import { useSelector } from "react-redux";

const CorporateEmployeeGroupList = ({ params }: any) => {
  const { corporateInfo } = useSelector((state) => (state as any)?.authReducer);
  const route = useParams();
  const [form] = Form.useForm();
  const [limit, setLimit] = useState(16);
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [activeSearch, setActiveSearch] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [refetchState, setRefetchState] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(undefined);
  const [selectedGroupForEdit, setSelectedGroupForEdit] = useState(undefined);

  const [groupData, setGroupData] = useState({
    loading: false,
    data: null,
  });

  const getEmployeeGroup = useCallback(async () => {
    setGroupData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/company/admin/all?companyId=${corporateInfo?.id}` +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setGroupData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setGroupData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [limit, page]);

  useEffect(() => {
    getEmployeeGroup();
  }, [getEmployeeGroup]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(undefined);
    setSelectedGroupForEdit(!setSelectedGroupForEdit);
    setSelectedEmployee(!setSelectedEmployee);
    // refetch();
    form.resetFields();
    setRefetchState(true);
    getEmployeeGroup();
  };

  return (
    <React.Fragment>
      <CorporateLayout corporateId={(route as any)?.corporateId as string}>
        <div className="product-list-item-area white-bg">
          <HubHeader
            leftarea={"Employee Group List"}
            rightarea={
              <div className="d-flex">
                <Button type="primary" danger onClick={showDrawer}>
                  Add New
                </Button>
              </div>
            }
          />
          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="">
              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading">
                      <span>Group Name</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Action</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                {groupData?.loading ? (
                  <Loading />
                ) : (
                  <div className="product-table">
                    <div className="product-table-area">
                      {groupData?.data?.groups?.length ? (
                        groupData?.data?.groups?.map((group, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="single-product-wrapper"
                              // onClick={() => setSelectedEmployee(group)}
                            >
                              <div className="single-product">
                                <span className="name">{group?.groupName}</span>
                              </div>

                              <div className="single-product">
                                <span className="name">{group?.status}</span>
                              </div>
                              <div className="single-product">
                                <Link
                                  to=""
                                  className="btn btn-sm btn-warning mx-1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedGroupForEdit(group);
                                  }}
                                >
                                  <EditOutlined />
                                </Link>
                              </div>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <Empty />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...groupData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>

          <Drawer
            destroyOnClose={true}
            title="Add Group"
            width={500}
            onClose={onClose}
            visible={!!visible || selectedGroupForEdit}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddEmployeeGroup
              visibleData={selectedGroupForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>
        </div>
      </CorporateLayout>
    </React.Fragment>
  );
};

export default CorporateEmployeeGroupList;
